<template>
  <div v-if="localEntries.length">
    <div class="text-uppercase text-bold text-small text-muted mrgb-">
      {{
        $t('directories.directory.entries-count', {
          count: localEntries.length,
        })
      }}
    </div>

    <Draggable
      v-model="localEntries"
      tag="ul"
      class="list-stacked list-stacked--tight"
      handle=".handle"
      force-fallback="true"
      @change="updateEntries"
    >
      <li v-for="entry in localEntries" :key="entry.id">
        <DirectoryEntry
          :directory="directory"
          :entry="entry"
          draggable
          v-on="$listeners"
        />
      </li>
    </Draggable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';
import Draggable from 'vuedraggable';

import DirectoryEntry from '@/components/directory/DirectoryEntry.vue';

export default {
  components: {
    Draggable,
    DirectoryEntry,
  },

  props: {
    directory: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      localEntries: [],
    };
  },

  watch: {
    directory: {
      handler(directory) {
        if (directory && directory.entries)
          this.localEntries = directory.entries;
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions('directories', ['updateDirectory']),

    updateEntries({ moved }) {
      const newList = [...this.localEntries].map((item, index) => {
        if (item.order !== index) {
          item.order = index;
        }
        return item;
      });

      this.localEntries = newList.sort((a, b) => (a.order > b.order ? 1 : -1));
      this.updateDirectory({
        ...this.directory,
        entries: this.localEntries,
      });
    },
  },
};
</script>
